import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

import reAgentNew from '../../../features/users/components/marketplace/icons/agent_new.png'

export const RealEstateAgent: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ..._props }, _ref) => {
  return (
    <img src={reAgentNew} alt="Real Estate Agent" width={size} height={size} style={{ width: size, height: size }} />
  )
})

RealEstateAgent.displayName = 'RealEstateAgent'
